export default "<div class=\"modal-block\" *ngIf=\"modalService.activeModal$ | async\">\r\n  <ng-template #output></ng-template>\r\n</div>\r\n";